var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagForScotland(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-hidden": "true",
    role: "img",
    className: "iconify iconify--emojione",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 30,
    fill: "#0065BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.972 16.974L38.539 32l19.433 15.026a30.05 30.05 0 0 1-2.046 3.075l-.36.466a30.18 30.18 0 0 1-2.492 2.785L32 37.056L10.926 53.352a30.166 30.166 0 0 1-2.49-2.782l-.364-.471a30.044 30.044 0 0 1-2.044-3.073L25.461 32L6.028 16.974A30.045 30.045 0 0 1 8.074 13.9l.36-.466a30.158 30.158 0 0 1 2.492-2.784L32 26.944l21.074-16.296c.887.876 1.72 1.807 2.494 2.787l.356.461a30.04 30.04 0 0 1 2.048 3.078z",
    fill: "#EEE"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagForScotland);
export default __webpack_public_path__ + "static/media/flag-for-scotland.28646676f9dc3545283195226c96827a.svg";
export { ForwardRef as ReactComponent };